import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ActivatedRoute, Data, Router} from '@angular/router';
import {JhiEventManager} from 'ng-jhipster';
import {VaiTro} from '@entities/vai-tro/vai-tro.model';
import {VaiTroService} from '@entities/vai-tro/vai-tro.service';

import {Title} from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-user-role-delete-dialog',
  templateUrl: './user-role-delete-dialog.component.html',
})
export class UserRoleDeleteDialogComponent {
  role: VaiTro;
  @HostListener('window:keyup.esc')
  private onKeyUp() {
    this.dialogRef.close();
  }

  constructor(
    private dialogRef: MatDialogRef<UserRoleDeleteDialogComponent>,
    private vaiTroService: VaiTroService,
    private eventManager: JhiEventManager,
  ) {}

  confirmDelete(id: any) {
    this.vaiTroService.delete(id).subscribe((res) => {
      this.eventManager.broadcast({
        name: 'userRoleModification',
        content: 'User',
      });
      this.eventManager.broadcast({
        name: 'donViRoleModification',
        content: 'User',
      });
      this.dialogRef.close(true);
    });
  }
}

@Component({
  selector: 'app-user-role-delete-popup',
  template: '',
})
export class UserRoleDeletePopupComponent implements OnInit, OnDestroy {
  private dialogRef: MatDialogRef<UserRoleDeleteDialogComponent>;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private titleService: Title,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.titleService.setTitle(
      this.translate.instant('admin.user-role-delete.Xóa vai trò_title'),
    );
    this.activatedRoute.data.subscribe(({role}: Data) => {
      setTimeout(() => {
        this.dialogRef = this.dialog.open(UserRoleDeleteDialogComponent, {
          disableClose: true,
          width: '500px',
        });

        this.dialogRef.componentInstance.role = role;
        this.dialogRef.afterClosed().subscribe(
          (result) => {
            this.router.navigate([{outlets: {popup: null}}], {
              replaceUrl: true,
              queryParamsHandling: 'merge',
            });
          },
          (reason) => {
            this.router.navigate([{outlets: {popup: null}}], {
              replaceUrl: true,
              queryParamsHandling: 'merge',
            });
          },
        );
      }, 0);
    });
  }

  ngOnDestroy() {
    this.titleService.setTitle(
      this.translate.instant(
        'admin.user-role-delete.Phân quyền người dùng_title',
      ),
    );
    this.dialogRef = null;
  }
}
